<div class="d-flex gap-3 flex-column">
    <div class="d-flex flex-column flex-md-row w-100 align-items-start align-items-md-center gap-4">
        <label class="small text-nowrap" [ngStyle]="{'width': width}" *ngIf="label">
            {{label}}
            <span *ngIf="control?.hasError('required')" style="color: red;">*</span>
        </label>

        <ng-select appearance="outline" [placeholder]="placeholder" (ngModelChange)="onValueChange($event)"
            (blur)="onTouched()" [disabled]="control?.disabled ?? false" [items]="items$ | async"
            [bindLabel]="currentBindLabel" [bindValue]="bindValue" [(ngModel)]="value"
            [searchFn]="disableLocalFilter" (search)="onSearch($event.term)" [loading]="isLoading"
            (scrollToEnd)="onLoadMore()" (clear)="onClearSearch()" [appendTo]="appendTo" [clearable]="true"
            [minTermLength]="0">
            <ng-template ng-label-tmp let-item="item" *ngIf="!writeValueFlag">
                <span class=""> {{ placeholder }}</span>
            </ng-template>
        </ng-select>

    </div>
    <div class="d-flex flex-row w-100 align-items-center justify-content-end">
        <span class="error-label" *ngIf="isInvalid()">
            {{errorMessage}}
        </span>
    </div>
</div>
